import React from 'react'
import { Route, Routes } from 'react-router-dom'
import HomePage from '../Pages/HomePage'
import PaymentPage from '../Pages/PaymentPage'
import CustomerInfo from '../Pages/CustomerInfo'
import Auth from './Auth'
import Login from './Login/Login'
import ErrorPage from '../Pages/ErrorPage'
import ContactPage from '../Pages/ContactPage'
import SoaPage from '../Pages/SoaPage'

const Router = () => {
  return (
    <Routes>
        <Route path="/" element={<Auth><HomePage/></Auth>}/>
        <Route path="/soa" element={<Auth><SoaPage/></Auth>}/>
        <Route path="/payment/:customerNumber?/:groupNumber?" element={<Auth><PaymentPage/></Auth>}/>
        <Route path="/multiplePayment/:customerNumber?/:selectedCustomers" element={<PaymentPage />} />
        <Route path="/customerDetails" element={<Auth><CustomerInfo/></Auth>}/>
        <Route path="/login" element={<Login/>}/>
        <Route path="*" element={<ErrorPage />} /> {/* Catch-all route */}
        <Route path='/contact-us' element={<ContactPage/>}/>
    </Routes>
  )
}

export default Router